import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector,useDispatch } from 'react-redux';
import {
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CRow,
	CCol,
	CLink,
	CTooltip,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { 
	MyPage500,
	MyFormHapus,
	MyPagination,
} from '../components/index';
import { UFunc } from "../helpers/functions";
import { Konfirm } from '../helpers/onConfirm';
import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";

let pjson     	= require('../../package.json');
const Pecahstok = (props) => {
	const uComponentname 	= Pecahstok.name;
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	let uFuncname;
	const uNavigate  		= useNavigate();
	const uDispatch			= useDispatch();
	const uTokenObj			= JSON.parse(localStorage.getItem("token"));
	const uBahasaObj  		= useSelector(state => state.listBahasa);

	const uActiveRoute  	= useSelector(state => state.activeRoute);
	const uHTMLstyleTabel	= useSelector(state => state.gHTMLstyleLaporan);
	const uIsScrollBottom	= useSelector(state => state.gIsScrollBottom);
	const uIsEOMExecuted	= useSelector(state => state.gIsEOMExecuted);
	const uDefaultSettingObj= useSelector(state => state.gListDefaultSetting);
	const uUserSettingObj 	= useSelector(state => state.gListUserSetting);
	const uEfekapp			= useSelector(state => state.effectApp);
	const [uEfekview,setEfekview]			= React.useState(false);

	const uKeywordObj		= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uHeaderActionObj  = useSelector(state => state.gInitHeaderAction);
	const uHandelView 		= uHeaderActionObj.isHeaderView || false;
	const uHandelTambah 	= uHeaderActionObj.isHeaderTambah || false;

	//--GLOBAL_VARS--/
	const uIsInitHapus		= (uTokenObj.userhak==="FREEROLE" || uTokenObj.userhak ==="ADMIN") && uIsEOMExecuted 
	const uMaxData			= isMobile ? (uUserSettingObj.jml_mobile || 20) : (uUserSettingObj.jml_laporan || 100);
	const [uHTMLError500,setHTMLError500]	= React.useState(null);
	const [uFirstload,setFirstload]			= React.useState("YA");

	const [uTabelRowSelect,setTabelRowSelect]= React.useState(-1);
	const [uTabelIDPilih,setTabelIDPilih]	= React.useState(0);
	const [uJmlData,setJmlData]				= React.useState(0);
	const [uDatamainArr,setDatamainArr]		= React.useState([]);
	const [uJmlHal,setJmlHal]				= React.useState(1);
	const [uPageActive,setPageActive]		= React.useState(1);
	const [uTimeElapsed,setTimeElapsed]		= React.useState(0);

	//---FORMDIALOG--/
	const [isFormhapusShow,setFormhapusShow]= React.useState(false);
	const [uFormhapusHeader,setFormhapusHeader]= React.useState("");
	const [uInpKethapus,setInpKethapus]		= React.useState("");
	//---END FORMDIALOG--/

	const uElJmldata	= document.getElementById("idjmldata");
	//--END GLOBAL_VARS--/

	//---HANDLE--/
	const hdlToggleFormhapus=()=>{ setFormhapusShow(false); }
	const hdlKlikFormhapus=()=>{
		//--VALIDASI--/
		if((uInpKethapus||"").trim() === "") {
			document.getElementById("inpketerangan") 
				&& document.getElementById("inpketerangan").focus();
			showToast((uBahasaObj.pesan_penghapusanharusdiisi||"pesan_penghapusanharusdiisi")); 
			return;
		}
		//--END VALIDASI--/
		apiHapus(uTabelIDPilih);
	}
	const hdlKlikHapus=(_IDTABEL)=>{
		_IDTABEL = parseInt(_IDTABEL) || 0;
		if(_IDTABEL <= 0) return;

		var vIdx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		var vRowIdx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL);
		setTabelRowSelect(vRowIdx);
		setTabelIDPilih(_IDTABEL);

		setFormhapusHeader(
			(uBahasaObj.caption_hapusdata||"caption_hapusdata")+": "+
			(UFunc.TglAngka(uDatamainArr[vIdx].tanggal))+" - "+
			(uDatamainArr[vIdx].nama_box_kecil).toUpperCase()+
			"");
		setFormhapusShow(true);
	}
	//---END HANDLE--/

	//---INIT_FUNCTION--/
	const initJmldata = () => {
		const vKeyword = uKeywordObj.kwd_pecahstok || "";

		if (vKeyword.length >= 3)
			uElJmldata && (uElJmldata.innerHTML = UFunc.formatAngka(uJmlData));
		else
			uElJmldata && (uElJmldata.innerHTML = "&#8734;");
	}
	//---END INIT_FUNCTION--/

	//---Init_CONTENT--/
	const contentMain = () => {
		if(uHTMLError500) return "";

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);
		const vKeyword 		= UFunc.filterRegex(uKeywordObj.kwd_pecahstok || "");
		const vKeywordcolor = uUserSettingObj.color_keyword;
		const vReplace 		= new RegExp(vKeyword,"ig");

		const vDataViewArr	= uDatamainArr.filter(vItems => 
			parseInt(vItems.pg||1)===parseInt(uPageActive||1))

		//console.log("("+uComponentname+"-contentMain) vDataViewArr => "+JSON.stringify(vDataViewArr));
		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
		<tr className="d-none d-md-table-row text-center classfontsmaller align-top">
		<th width={30} className="px-1">No</th>
		<th className="px-1">
			<CRow className="mx-0">
			<CCol md="2" className="text-start">{uBahasaObj.word_tanggal||"word_tanggal"}</CCol>
			<CCol md="5" className="text-start">{uBahasaObj.caption_barangbaru||"caption_barangbaru"}</CCol>
			<CCol md="4" className="text-start">{uBahasaObj.caption_barangdipecah||"caption_barangdipecah"}</CCol>
			<CCol md="1" className="">&middot;</CCol>
			</CRow>
		</th>
		</tr>

		<tr className="d-md-none">
			<th width={30} className="p-0"/>
			<th className="p-0"/>
		</tr>
		</thead>

		<tbody>
		{vDataViewArr.map((vItems,vKeys)=>{
			const {
				id,tanggal,nama_box_besar,sat_besar,nama_box_kecil,sat_kecil,
				jml_besar,jml_kecil,status_jurnal,
				username,tgl_input,init_expired
			} = vItems;

			vNumber++;
			const vCaptionUpper	= UFunc.HariAngka(tanggal)+" "+((nama_box_besar||"")).toUpperCase();

			const vTanggal	= vKeyword==="" ? UFunc.TglAngka(tanggal) 
				: (UFunc.TglAngka(tanggal)).replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vTglInput	= vKeyword==="" ? UFunc.WaktuAngka(tgl_input||"") 
				: (UFunc.WaktuAngka(tgl_input||"")).replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vNamaBesar= vKeyword==="" ? UFunc.capitalize(nama_box_besar||"") 
				: (UFunc.capitalize(nama_box_besar||"")).replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vSatBesar	= vKeyword==="" ? (sat_besar||"").toUpperCase()
				: ((sat_besar||"").toUpperCase()).replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vNamaKecil= vKeyword==="" ? UFunc.capitalize(nama_box_kecil||"") 
				: (UFunc.capitalize(nama_box_kecil||"")).replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vSatKecil = vKeyword==="" ? (sat_kecil||"").toUpperCase()
				: ((sat_kecil||"").toUpperCase()).replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");
			const vUsername = vKeyword==="" ? (username||"undf").toUpperCase()
				: ((username||"undf").toUpperCase()).replace(vReplace,"<strong><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></strong>");

			const vColorstatustembak = (status_jurnal||"")==="TEMBAK" ? "text-primary" : "";

			return (
			<tr id={"idtr"+id} className={"align-top text-end"+(uTabelRowSelect===vKeys?" classrowselect":"")} 
				key={vKeys}>
			<td className="px-1 pe-1">{(vNumber)}.</td>
			<td className="px-1">
			<CRow className="mx-0">
				<CCol xs="12" md="2" className="px-1 text-start d-flex justify-content-between">
					<div>
					{UFunc.renderHTML(vTanggal)}
					{uTokenObj.userhak==="FREEROLE" && (
						<span className="classfontsmaller"> &middot; <small>({id})</small></span>
					)}
					
					<div className="d-none d-md-block classfontsmaller text-danger">
						<small>[
						{UFunc.TglAngka(tanggal||"")!==UFunc.TglAngka(tgl_input||"") && (
							<>
							{UFunc.renderHTML(vTglInput)}
							<span className="mx-1">&middot;</span>
							</>
						)}
						<span className="text-uppercase">{UFunc.renderHTML(vUsername)}</span>
						]</small>
					</div>
					</div>

					{(uIsInitHapus && uIsEOMExecuted && (init_expired||"TIDAK")==="TIDAK") && (
						<CLink className="classikontabel classikonhapus d-md-none"
							onClick={()=>hdlKlikHapus(id)} />
					)}
				</CCol>
				
				<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

				<CCol xs="4" className="px-1 text-start d-md-none classfontsmaller">{uBahasaObj.caption_barangbaru||"caption_barangbaru"}</CCol>
				<CCol xs="8" md="5" className="px-1 text-md-start">
					<div>
						{UFunc.renderHTML(vNamaKecil)}
						<span className="d-none d-md-inline me-1">:</span>
						<small className="d-none d-md-inline text-success"><b>{UFunc.formatAngka(jml_kecil)}</b> {UFunc.renderHTML(vSatKecil)}</small>
					</div>
				</CCol>
				
				<CCol xs="6" className="px-1 text-start d-md-none classfontsmaller">{uBahasaObj.caption_jmlbaru||"Jml Pecahan Baru"}</CCol>
				<CCol xs="6" className="px-1 d-md-none">
					<span className="text-success"><b>{UFunc.formatAngka(jml_kecil)}</b> {UFunc.renderHTML(vSatKecil)}</span>
				</CCol>
				
				<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

				<CCol xs="4" className="px-1 text-start d-md-none classfontsmaller">{uBahasaObj.caption_barangdipecah||"caption_barangdipecah"}</CCol>
				<CCol xs="8" md="4" className="px-1 text-md-start">
					{UFunc.renderHTML(vNamaBesar)}
					<span className="d-none d-md-inline me-1">:</span>
					<small className="d-none d-md-inline text-info"><b>{UFunc.formatAngka(jml_besar)}</b> {UFunc.renderHTML(vSatBesar)}</small>
				</CCol>
				
				<CCol xs="6" className="px-1 text-start d-md-none classfontsmaller">{uBahasaObj.caption_jmldipecah||"Jml Dipecah"}</CCol>
				<CCol xs="6" className="px-1 d-md-none">
					<span className="text-info"><b>{UFunc.formatAngka(jml_besar)}</b> {UFunc.renderHTML(vSatBesar)}</span>
				</CCol>

				<CCol xs="12" className="px-1 my-3 d-md-none classborderbottom"/>

				<CCol xs="5" className="px-1 text-start d-md-none"><small>{uBahasaObj.caption_inputby||"Inputby"}</small></CCol>
				<CCol xs="7" className="px-1 d-md-none classfontsmaller text-danger">
					<small>[
						{UFunc.TglAngka(tanggal||"")!==UFunc.TglAngka(tgl_input||"") && (
							<>
							{UFunc.renderHTML(vTglInput)}
							<span className="mx-1">&middot;</span>
							</>
						)}
						<span className="text-uppercase">{UFunc.renderHTML(vUsername)}</span>
					]</small>
				</CCol>
				
				<CCol md="1" className="px-1 text-center d-none d-md-block">
				{(uIsInitHapus && uIsEOMExecuted && (init_expired||"TIDAK")==="TIDAK") ? (
				<CTooltip content={"--"+(uBahasaObj.caption_hapusdata||"caption_hapusdata")+": "+vCaptionUpper}>
					<CLink className="classikontabel classikonhapus classcursorpointer"
						onClick={()=>hdlKlikHapus(id)} />
				</CTooltip>
				): (<>&middot;</>)}
				</CCol>
			</CRow>
			</td>
			</tr>
			);
		})}
		</tbody>
		</table>
		)//>
	}
	//---END Init_CONTENT--/

	//---API_FUNC--/
	const apiLoaddata = (_PAGE) => {
		uFuncname	= apiLoaddata.name;
		_PAGE		= parseInt(_PAGE) || 1;
		setHTMLError500();

		const vKeyword 		= uKeywordObj.kwd_pecahstok || "";
		const vHandelview	= ((uHandelView||false)===true || uFirstload==="YA")
			?"YA":"TIDAK";
		let vDatamainArr 	= uDatamainArr;
		if(vHandelview==="YA") {
			vDatamainArr	= [];
		} else {
			if(uDatamainArr.length >= 10000) {
				vDatamainArr	= uDatamainArr.filter(vItems=>parseInt(vItems.pg||1)===1);
			} else {
				vDatamainArr	= uDatamainArr.filter(vItems=>parseInt(vItems.pg||1)!==_PAGE);
			}
		}
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("("+uComponentname+"-apiLoaddata) LEWAT ");
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			setLoading(false);
		},3000);return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_keyword : vKeyword,
			send_pg: _PAGE,
			send_maxdata	: uMaxData,
			send_loadjml	: vHandelview,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_pecahstok/ld_data";

		setTimeElapsed(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if(response.status === 200){ setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			//console.log("("+uComponentname+"-"+uFuncname+") output_string : "+JSON.stringify(output_string.errors));
			if(output_string.tampil) {
				const vLoadArr = JSON.parse(output_string.dataobject||"[]");
				vLoadArr.map(vItems=>vItems.pg = _PAGE);

				setDatamainArr([...vDatamainArr,...vLoadArr]);
				if(vKeyword.length >= 3)
					setJmlData(parseInt(output_string.totaldata||uJmlData))
				else setJmlData(vLoadArr.length);

				setFirstload("TIDAK");

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeElapsed(vTimeDiff);
			} else if(output_string.info) {
				setHTMLError500(output_string.info);
			} else if(output_string.errors) {
				console.log("("+uComponentname+"-"+uFuncname+") output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHTMLError500("<span class='text-danger'>"+vMsg+"</span>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(uNavigate);
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("("+uComponentname+"-"+uFuncname+") catch-error: "+error);
			setHTMLError500(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiHapus = (_IDTABEL) => {
		uFuncname 	= apiHapus.name;
		_IDTABEL = parseInt(_IDTABEL) || 0;
		const vIdx= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		document.getElementById("btnDialogSimpan") &&
			(document.getElementById("btnDialogSimpan").disabled = true);

		/*//---TESTING_FRONTEND--/
		console.log("("+uComponentname+"-"+uFuncname+") uTabelIDPilih : "+uTabelIDPilih);
		return;
		//---END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : _IDTABEL,
			send_keterangan: uInpKethapus,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_pecahstok/pr_hapus";

		document.getElementById("btnDialogSimpan").disabled = true;
		setLoading(true);
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if(response.status === 200){ setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			document.getElementById("btnDialogSimpan") &&
				(document.getElementById("btnDialogSimpan").disabled = false);

			if(output_string.sukses) {
				uDatamainArr.splice(vIdx,1);
				setTabelRowSelect(-1);
				setJmlData((parseInt(uDatamainArr.length)||0));

				hdlToggleFormhapus();
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("("+uComponentname+"-"+uFuncname+") output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			document.getElementById("btnDialogSimpan") &&
				(document.getElementById("btnDialogSimpan").disabled = false);
			setLoading(false);
			console.log("("+uComponentname+"-"+uFuncname+") catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//---END API_FUNC--/

	//---EFFECT--/
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

    	apiLoaddata();

    	return () => { 
			uDispatch({type: "set", gInitHeaderAction: {}});
			hdlToggleFormhapus();
    		setDatamainArr([]); setFirstload("YA");
    	}
	},[]);
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		setJmlData(0);
		setDatamainArr([]);
		setTabelIDPilih(0);
		setTabelRowSelect(-1);
		setPageActive(1);

		apiLoaddata();
	},[uHandelView]);
	React.useEffect(()=>{
		if(!uHandelTambah) return;

		uHeaderActionObj.isHeaderTambah = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHTMLError500 || !uIsEOMExecuted) return;

		uNavigate("/substok/pecahstok/forminput");
	},[uHandelTambah]);
	React.useEffect(()=>{ uElJmldata && initJmldata() },[uElJmldata]);
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
		//setPageActive(uPageActive<=0?1:uPageActive);

		initJmldata()
	},[uJmlData]);
	React.useEffect(()=>{
		if(uFirstload==="YA") return;

		setTabelIDPilih(0);
		setTabelRowSelect(-1);
		const vDatapageArr = uDatamainArr.filter(vItems=>parseInt(vItems.pg||1)===parseInt(uPageActive||1));
		if(vDatapageArr.length > 0) { 
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}

		apiLoaddata(uPageActive);
	},[uPageActive]);
	React.useEffect(()=>{});
	React.useEffect(()=>{
		if(!isFormhapusShow) { setInpKethapus(""); return;}

		let vTimeout = setTimeout(function(){
			document.getElementById("inpketerangan") && document.getElementById("inpketerangan").focus();
			clearTimeout(vTimeout);
		},350);
	},[isFormhapusShow]);
	React.useEffect(()=>{
		if(!uHTMLError500) {
			uDispatch({type: "set", gStillError500Bl: undefined}); 
			return;
		}

		uDispatch({type: "set", gStillError500Bl: true}); 
	},[uHTMLError500]);
	//---END EFFECT--/

	//console.log("("+uComponentname+") Checked..");//---KALO_GA_ADA_YG_PAKE_uComponentname
	if(UFunc.isEmpty(uTokenObj)) { setLoading(true); prosesExpired(); return ""; }
	if(uHTMLError500) return (<MyPage500 content={uHTMLError500} {...props}/>)//>

	return (
		<>
		<CCard className="classcardbg mb-3">
			<CCardHeader className="d-flex justify-content-between align-items-center">
			<small className="text-primary">
				<span className="">Rekap Input</span>
				
				<span className="d-md-none fw-bolder">
					<span className="mx-1">&middot;</span>
					{(()=>{
						const vKeyword = uKeywordObj.kwd_pecahstok || "";
						if(vKeyword.length < 3) {
							return (<>&#8734;</>)
						}

						return "("+UFunc.formatAngka(uJmlData)+")"
					})()}
				</span>
			</small>
			<span className="text-muted classfontsmaller">
				<small>{UFunc.formatAngka(uTimeElapsed)}ms</small>
			</span>
			</CCardHeader>

			<CCardBody className="px-0">{contentMain()}</CCardBody>

			{(uJmlData > uMaxData) && (
			<CCardFooter>
				<MyPagination
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i) => setPageActive(i)}/>
			</CCardFooter>
			)}
		</CCard>

		<MyFormHapus
			value={uInpKethapus}
			onCHvalue={(e)=>setInpKethapus(e.target.value)}
			onSimpan={()=>hdlKlikFormhapus()}
			show={isFormhapusShow} 
			dialogHeader={uFormhapusHeader}
			toggle={hdlToggleFormhapus}/>
		</>
	)//>
}
	
export default Pecahstok;
